export default "__VITE_ASSET__BsqqQMh9__"